import src from "IMAGE";
export default { src, width: 5571, height: 906, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AH467/S5od9ov7+/P76+vkDCwsI8wsLCPMzMzDLg4OAeVc0Ui1xI19wAAAAASUVORK5CYII="};
